function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useEffect, useRef, useState } from 'react';
import { arrayOf, func, node, shape, string } from 'prop-types';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import SovosTypography from "../../sovos-typography";
import { headerPadding } from "../../internals/page-layout/contentPadding";
import SovosFixedWidthText from "../../sovos-fixed-width-text/SovosFixedWidthText";
import SovosButtonsGroup from "../../sovos-buttons-group/SovosButtonsGroup";
import sovosIconButtonElement from "../../internals/prop-types/sovosIconButtonElement";
import Breadcrumbs from "./Breadcrumbs";
import { useWindowSize } from "../../hooks";
var Root = styled('div')(function (_ref) {
  var _ref$theme = _ref.theme,
    breakpoints = _ref$theme.breakpoints,
    palette = _ref$theme.palette,
    spacing = _ref$theme.spacing,
    transitions = _ref$theme.transitions;
  return _objectSpread(_objectSpread({}, headerPadding(breakpoints, spacing)), {}, {
    backgroundColor: palette.background.default,
    flex: '0 0 auto',
    height: spacing(9),
    overflow: 'hidden',
    padding: "".concat(spacing(2), " ").concat(spacing(4)),
    transition: "height ".concat(transitions.duration.standard, "ms ease-out"),
    zIndex: 20,
    '&.sovosPageTitleBar--hasBreadcrumbs': {
      height: spacing(11)
    }
  });
});
var TitleRow = styled('div')({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  maxWidth: '100%',
  whiteSpace: 'nowrap'
});
var PageTitle = styled(SovosTypography)(function (_ref2) {
  var palette = _ref2.theme.palette;
  return {
    color: palette.text.primary,
    flex: '1 1 auto',
    overflow: 'hidden'
  };
});
var titleElementProps = {
  text: string.isRequired,
  onClick: func
};
var tabElementProps = {
  icon: node,
  label: string.isRequired
};
export var calculateBreadCrumbOverflowState = function calculateBreadCrumbOverflowState(prevContainerWidth, prevAncestorsCollapsed, prevParentCollapsed, containerWidth, scrollWidth) {
  var ancestorsCollapsed;
  var parentCollapsed;

  // breadcrumb container growing; expand breadcrumbs and let them be
  // re-collapsed if they don't fit
  if (prevContainerWidth < containerWidth) {
    parentCollapsed = false;
    ancestorsCollapsed = false;
  }

  // breadcrumb container too small, let's collapse some breadcrumbs!
  if (containerWidth < scrollWidth) {
    if (!prevParentCollapsed && prevAncestorsCollapsed) {
      parentCollapsed = true;
    }
    if (!prevAncestorsCollapsed) {
      ancestorsCollapsed = true;
    }
  }
  return [ancestorsCollapsed, parentCollapsed];
};
var PageTitleBar = function PageTitleBar(_ref3) {
  var actions = _ref3.actions,
    pageCrumbs = _ref3.pageCrumbs,
    pageTitle = _ref3.pageTitle,
    titleIconButton = _ref3.titleIconButton;
  var breadcrumbContainerRef = useRef();
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    breadcrumbContainerWidth = _useState2[0],
    setBreadCrumbContainerWidth = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    breadcrumbAncestorsCollapsed = _useState4[0],
    setBreadCrumbAncestorsCollapsed = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    breadcrumbParentCollapsed = _useState6[0],
    setBreadCrumbParentCollapsed = _useState6[1];
  var _useWindowSize = useWindowSize(),
    windowWidth = _useWindowSize.width;
  var hasBreadcrumbs = !!(pageCrumbs !== null && pageCrumbs !== void 0 && pageCrumbs.length);
  useEffect(function () {
    if (!breadcrumbContainerRef.current) {
      return;
    }
    var _breadcrumbContainerR = breadcrumbContainerRef.current,
      offsetWidth = _breadcrumbContainerR.offsetWidth,
      scrollWidth = _breadcrumbContainerR.scrollWidth;
    var _calculateBreadCrumbO = calculateBreadCrumbOverflowState(breadcrumbContainerWidth, breadcrumbAncestorsCollapsed, breadcrumbParentCollapsed, offsetWidth, scrollWidth),
      _calculateBreadCrumbO2 = _slicedToArray(_calculateBreadCrumbO, 2),
      ancestorsCollapsed = _calculateBreadCrumbO2[0],
      parentCollapsed = _calculateBreadCrumbO2[1];
    if (ancestorsCollapsed != null || parentCollapsed != null) {
      setBreadCrumbContainerWidth(offsetWidth);
    }
    if (ancestorsCollapsed != null) {
      setBreadCrumbAncestorsCollapsed(ancestorsCollapsed);
    }
    if (parentCollapsed != null) {
      setBreadCrumbParentCollapsed(parentCollapsed);
    }
  }, [breadcrumbContainerWidth, breadcrumbParentCollapsed, breadcrumbAncestorsCollapsed, windowWidth]);
  return /*#__PURE__*/React.createElement(Root, {
    className: clsx('sovosPageTitleBar', hasBreadcrumbs && 'sovosPageTitleBar--hasBreadcrumbs')
  }, hasBreadcrumbs && /*#__PURE__*/React.createElement(Breadcrumbs, {
    ref: breadcrumbContainerRef,
    parentCollapsed: breadcrumbParentCollapsed,
    ancestorsCollapsed: breadcrumbAncestorsCollapsed,
    pageCrumbs: pageCrumbs
  }), /*#__PURE__*/React.createElement(TitleRow, null, /*#__PURE__*/React.createElement(PageTitle, {
    variant: "h4",
    component: "h1",
    role: "heading"
  }, /*#__PURE__*/React.createElement(SovosFixedWidthText, {
    text: pageTitle
  }), titleIconButton), (actions === null || actions === void 0 ? void 0 : actions.length) && /*#__PURE__*/React.createElement(SovosButtonsGroup, {
    className: "sovosPageTitleBar__actions",
    "data-testid": "sovosPageTitleBar__actions"
  }, actions)));
};
PageTitleBar.propTypes = {
  actions: node,
  pageCrumbs: arrayOf(shape(titleElementProps)),
  pageTitle: string.isRequired,
  titleIconButton: sovosIconButtonElement
};
export var TitleElementProps = titleElementProps;
export var TabElementProps = tabElementProps;
export default PageTitleBar;